const faqs = [
    {
        id: 1,
        heading: 'How do I book a wedding planner?',
        content:
        'Booking a wedding planner with us is simple! You can get in touch via our website, fill out our contact form, or call our office. We will arrange a consultation to understand your vision and preferences.',
    },
    {
        id: 2,
        heading: 'What payment methods do you accept?',
        content:
        'We accept credit/debit cards, bank transfers, and mobile payments. Our team will discuss the payment options that work best for you during the consultation process.',
    },
    {
        id: 3,
        heading: 'What is your cancellation policy?',
        content:
        'If you need to cancel your booking, you can do so free of charge up to 60 days before the wedding date. After this period, a cancellation fee will apply based on the services already rendered.',
    },
    {
        id: 4,
        heading: 'What services do you offer?',
        content:
        'We provide a comprehensive range of wedding planning services, including venue selection, vendor management, decor, catering, and on-day coordination. We tailor our services to meet your unique needs.',
    },
    {
        id: 5,
        heading: 'Can I customize my wedding plan?',
        content:
        'Absolutely! Every wedding we plan is unique. We work closely with you to understand your preferences, ensuring that every detail, from the theme to the decor, reflects your vision.',
    },
];

export default faqs;